module.exports = __webpack_public_path__ + "img/Roboto-LightItalic.dfc37d93.svg";